<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="2" :lg="2" :md="2">
            <div>
              <el-select v-model="selectedChannelId" placeholder="请选择渠道" clearable="true" size="medium">
                <el-option v-for="channel in channels" :key="channel.channelId" :label="channel.channelName"
                  :value="channel.channelId">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" :lg="6" :md="6" style="padding-left: 5px;">
            <div>
              <el-date-picker v-model="createTime" style="width: 97%" type="datetimerange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" size="medium" :editable="true" :clearable="true">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" :lg="4" :md="5">
            <div>
              <el-input placeholder="请输入电话号码" v-model="telephone" style="width: 180px;" size="medium" clearable>
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" :lg="5" :md="6" style="padding-left: 10px;">
            <div>
              <el-button type="primary" size="medium" icon="el-icon-search" @click="searchFeedback">搜索</el-button>
              <el-button type="success" size="medium" @click="exportFeedback"
                v-if="checkButtonPermission('feedback:manage:export')">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%" max-height="400">
          <el-table-column prop="createAt" label="时间" width="140"></el-table-column>
          <el-table-column prop="wechatNickName" label="微信昵称" width="120"></el-table-column>
          <el-table-column prop="userName" label="姓名" width="100"></el-table-column>
          <el-table-column prop="realName" label="真实姓名" width="100"></el-table-column>
          <el-table-column prop="telephone" label="电话" width="120"></el-table-column>
          <el-table-column prop="channelName" label="渠道" width="180"></el-table-column>
          <el-table-column prop="content" label="反馈意见"></el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 25, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "feedbackList",
  data() {
    return {
      tableData: [
      ],
      currentPage: 1,
      pageSize: 10,
      totalPage: 100,
      total: 100000,
      telephone: '',
      createTime: [],
      startCreateTime: null,
      endCreateTime: null,
      channels: [],
      selectedChannelId: ''
    }
  },
  created() {
    this.searchFeedback();
    this.getChannels();
  },
  methods: {
    openDialog(dialogOperation, data) {
      this.$alert(data.content, '此为用户微信昵称' + data.wechatNickName + '的反馈为：', {
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchFeedback();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchFeedback();
    },
    searchFeedback() {
      let reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize,
        startCreateTime: this.createTime[0],
        endCreateTime: this.createTime[1],
        telephone: this.telephone,
        channelId: this.selectedChannelId
      };
      this.$http.post('/api/user/feedback/list', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let pageInfo = resp.data.pageInfo;
        this.tableData = pageInfo.list;
        this.pageSize = pageInfo.pageSize;
        this.total = pageInfo.total;
      }).catch(e => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + e, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    exportFeedback() {
      this.$http({
        url: '/api/user/feedback/export',
        method: 'post',
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        },
        responseType: 'blob',
        data: {
          startCreateTime: this.createTime[0],
          endCreateTime: this.createTime[1],
          telephone: this.telephone,
          channelId: this.selectedChannelId
        }
      }).then(res => {
        let blob = new Blob([res.data], { type: res.headers['content-type'] });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '反馈列表.xlsx'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(e => {

      })
    },
    getChannels() {
      this.$http.post('/api/channel-service/channel/logged/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp.data.resultList)
        let data = resp.data;
        this.channels = data.resultList;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      });
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style>
.span_hide {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  height: 24px;
  display: block;
}

.span_hover:hover {
  cursor: pointer;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/feedback/feedbackList.vue